<template>
    <div
        v-if="!allAreEmpty"
        class="mini-hero-banner"
    >
        <client-only>
            <div class="container">
                <div class="row mini-hero-banner__row">
                    <template
                        v-for="(side, index) in sides"
                    >
                        <SingleMiniHeroBanner
                            v-if="emptySides.indexOf(side) < 0"
                            :key="`miniHeroBannerSingle${index}`"
                            class="col-12 col-lg-6"
                            :progressive-image="progressiveImage"
                            :class="`mini-hero-banner__slot--${side}`"
                            :double-click-slots="miniHeroBannerData[`${side}Slots`]"
                            :placeholder-slots="placeholders[`${side}Slots`]"
                            :side="side"
                            @empty="removeSingleHeroBanner"
                        />
                    </template>
                </div>
            </div>
        </client-only>
    </div>
</template>

<script>
import SingleMiniHeroBanner from '~/components/common/MiniHeroBanner/components/SingleMiniHeroBanner';
import miniHeroBannerData from '~/assets/json/miniHeroBanner.json';

export default {
    name: 'MiniHeroBanner',
    components: {
        SingleMiniHeroBanner,
    },
    props: {
        placeholders: {
            type: Object,
            default: () => ({}),
        },
        progressiveImage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            sides: ['left', 'right'],
            emptySides: [],
            miniHeroBannerData,
        };
    },
    computed: {
        allAreEmpty() {
            return this.emptySides.length && this.emptySides.every(emptySideName => this.sides.indexOf(emptySideName) >= 0);
        },
    },
    methods: {
        removeSingleHeroBanner(side) {
            this.emptySides.push(side);
        },
    },
};
</script>

<style lang="scss">
.mini-hero-banner {
    min-height: 234px;

    &__row {
        width: 100%;
        margin: 0 auto;
    }

    &__slot {
        &--left{
            padding-left: 0;
            padding-right: 12px;
        }

        &--right {
            padding-left: 12px;
            padding-right: 0;
        }
    }
}

@media (max-width: $breakpoint-big-desktop) {
    .mini-hero-banner {
        min-height: 187px;
    }
}

@media (max-width: $breakpoint-small-desktop) {
    .mini-hero-banner {
        min-height: 287px;
    }
}

@media (max-width: $breakpoint-tablet) {
    .mini-hero-banner {
        min-height: 110px;
    }
}
</style>
